import { render, staticRenderFns } from "./RequestForMaterialRevision.vue?vue&type=template&id=0181bed0"
import script from "./RequestForMaterialRevision.vue?vue&type=script&lang=js"
export * from "./RequestForMaterialRevision.vue?vue&type=script&lang=js"
import style0 from "./RequestForMaterialRevision.vue?vue&type=style&index=0&id=0181bed0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports